import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

function ContactUs() {
  return (
    <div className="contact-container">
      <h1 className="contact-title">Anekant Prakashan</h1>
      <div className="contact-cards">
        <div className="contact-card">
          <FaMapMarkerAlt className="contact-icon" />
          <h2 className="contact-heading">Address</h2>
          <p className="contact-info">
          18-A, Shraddha Sankul, 6th Lane,<br />
            Near IDBI Bank, JAYSINGPUR 416101,<br />
            Shirol, Kolhapur, Maharashtra
          </p>
        </div>

        <div className="contact-card">
          <FaPhoneAlt className="contact-icon" />
          <h2 className="contact-heading">Call Us</h2>
          <p className="contact-info">+91 9552826112</p>
        </div>

        <div className="contact-card">
          <FaEnvelope className="contact-icon" />
          <h2 className="contact-heading">Email Us</h2>
          <p className="contact-info">anekant.prakashan@gmail.com</p>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
